{
    "sectionHeader": "Statistica dei tempi di abbandono",
    "sectionPara": "È inoltre possibile regolare in modo specifico le soglie di durata dell'abbandono, utilizzate dalle sette varianti della statistica degli abbandoni in entrata in stile \"Abbandonato <= Xs\".",
    "target1Label": "Obiettivo 1:",
    "target1Placeholder": "60",
    "target2Label": "Obiettivo 2:",
    "target2Placeholder": "90",
    "target3Label": "Obiettivo 3:",
    "target3Placeholder": "120",
    "target4Label": "Obiettivo 4:",
    "target4Placeholder": "150",
    "target5Label": "Obiettivo 5:",
    "target5Placeholder": "180",
    "target6Label": "Obiettivo 6:",
    "target6Placeholder": "300",
    "targetUnits": "s",
    "resetAnswerTargetsButtonLabel": "Ripristino degli intervalli abbandonati",
    "resetAnswerTargetsPrompt": "È sicuro di voler ripristinare tutte e 6 le impostazioni della soglia di abbandono in entrata ai valori predefiniti?",
    "resetAnswerTargetsConfirm": "Confermare",
    "resetAnswerTargetsCancel": "Annullamento",
    "NAME": "AbandonedTimeStatisticLanguage"
}